<script setup>
import { computed } from 'vue';
import { useQuery } from 'villus';
import { useStore } from '@/store/Store.js';
import ProductGrid from './ProductGrid.vue';

const props = defineProps({
    ingredientIds: { type: Array, default: () => [] },
    titleTop: { type: String, default: '' },
    cta: { type: String, default: '' },
    bgClass: { type: String, default: 'bg-light-blue' },
    btnClass: { type: String, default: 'bg-dark-blue text-white' },
});

const store = useStore();
const variables = computed(() => ({
    lang: store.lang.value,
    productIngredients: props.ingredientIds,
}));

const q = `query FetchEntries($lang: [String], $productIngredients: [QueryArgument]) {
    products: entries (section: "product", site: $lang, orderBy: "RAND()", limit: 3, relatedTo: $productIngredients ) {
        id,
        title,
        uri,
        ... on product_Entry {
            color,
            ingredients: productIngredients { id, title },
            cover: productCover { 
                url @transform(format: "webp", quality: 80, width: 500, immediately: true), 
                title,
                height,
                width
            }
        }
    }
}`;

const { data } = await useQuery({
    variables,
    query: q,
});
</script>

<template>
    <ProductGrid
        :products="data.products"
        :title-top="titleTop"
        :cta="cta"
        :bg-class="bgClass"
        :btn-class="btnClass"
    />
</template>
